module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Commit-58ef1b28d6c6792283a826bb55ee54129c0d63f6ab486554b8c3eb6941066eae.svg";